module.exports = __webpack_public_path__ + "static/media/trash-black.df3b7745.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/icons/trash-black.svg
// module id = 831
// module chunks = 0